import React, { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import { ReportingSheet } from "./ReportingSheet";
import { useLocation as useRouterLocation } from "react-router-dom";

export function ReportingTrigger() {
    const [isOpen, setIsOpen] = useState(false);
    const routerLocation = useRouterLocation();

    // Hide on some pages where it might be intrusive or irrelevant
    const isHidden = [
        "/login",
        "/signup",
        "/admin",
    ].some(path => routerLocation.pathname.startsWith(path));

    if (isHidden) return null;

    return (
        <>
            <button
                onClick={() => setIsOpen(true)}
                className="p-1.5 hover:bg-sidebar-hover rounded-lg transition-colors"
                title="Provide feedback or report an issue"
            >
                <MessageSquarePlus className="w-5 h-5 text-header-text-muted" />
            </button>

            <ReportingSheet open={isOpen} onOpenChange={setIsOpen} />
        </>
    );
}
